export enum DragDropType {
  'plannerCard' ='plannerCard',
  'plannerGroup'= 'plannerGroup',
  'dockCard' = 'dockCard',
}
